import { render, staticRenderFns } from "./recall-command.vue?vue&type=template&id=fa25f33a&"
import script from "./recall-command.js?vue&type=script&lang=js&"
export * from "./recall-command.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports